import { Hidden, useMediaQuery } from "@material-ui/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";

import { ReactComponent as NoAccessImage } from "assets/no-access.svg";
import { Button, StyledGrid, StyledP } from "components/simple";
import {
  breakpoints,
  color,
  fontFamily,
  spacingDefaults
} from "style/constants";

interface WaitlistBannerProps {
  showButton?: boolean;
}

const WaitlistBanner: React.FC<WaitlistBannerProps> = ({
  showButton = false
}: WaitlistBannerProps) => {
  const mobile = useMediaQuery(`(max-width:${breakpoints.lg}px)`);
  const history = useHistory();

  return (
    <StyledGrid
      alignItems="center"
      backgroundColor={color.WHITE}
      borderRadius="8px"
      container
      height="96px"
      mobilePadding="0"
      onClick={
        mobile && showButton ? () => history.push("/resources") : undefined
      }
      overflow={mobile ? "hidden" : undefined}
      padding="20px"
    >
      <Hidden mdDown>
        <StyledGrid item position="relative" width="275px">
          <StyledGrid position="absolute" transform="translateY(-50%)">
            <NoAccessImage />
          </StyledGrid>
        </StyledGrid>

        <StyledGrid item xs>
          <StyledGrid marginBottom={spacingDefaults.xsmall}>
            <StyledP
              color={color.BLACK}
              fontFamily={fontFamily.secondary}
              fontSize="26px"
              letterSpacing="-0.5px"
            >
              You are currently on our <strong>waitlist</strong>
            </StyledP>
          </StyledGrid>
          <StyledP>
            We will e-mail you as soon as you have access to the Project.
          </StyledP>
        </StyledGrid>

        {showButton && (
          <StyledGrid item>
            <Link to="/resources">
              <Button longText width="175px">
                Explore Resources
              </Button>
            </Link>
          </StyledGrid>
        )}
      </Hidden>

      <Hidden lgUp>
        <StyledGrid item position="relative" width="115px">
          <StyledGrid
            left="-50px"
            position="absolute"
            transform="translateY(-50%)"
          >
            <NoAccessImage width={135} />
          </StyledGrid>
        </StyledGrid>

        <StyledGrid item xs>
          <StyledGrid>
            <StyledP
              color={color.BLACK}
              fontFamily={fontFamily.secondary}
              fontSize="20px"
              lineHeight="23px"
              width="200px"
            >
              You are currently on our <strong>waitlist</strong>
            </StyledP>
          </StyledGrid>

          {showButton && (
            <StyledGrid marginTop={spacingDefaults.xsmall}>
              <StyledP color={color.BLACK} fontSize="16px">
                <strong>Explore Resources &gt;</strong>
              </StyledP>
            </StyledGrid>
          )}
        </StyledGrid>
      </Hidden>
    </StyledGrid>
  );
};

export default WaitlistBanner;
